var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTablet = function SvgTablet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "tablet_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tablet_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 19q-.618 0-1.06-.44A1.45 1.45 0 0 1 3 17.5v-15q0-.62.44-1.06Q3.883 1 4.5 1h11q.619 0 1.06.44.44.442.44 1.06v15q0 .62-.44 1.06T15.5 19zm0-4.5v3h11v-3zm4 2h3v-1h-3zm-4-3.5h11V5h-11zm0-9.5h11v-1h-11z"
  }))));
};
export default SvgTablet;